export const traditionalMehndiMenus = [
  {
    title: "MENU 1",
    price: 2100,
    items: [
      "Chicken Qorma / Chicken Karahi",
      "Lahori Channay",
      "Aloo Achari",
      "Gulab Jaman & Firni Thothi",
      "Halwa Suji",
      "Fresh Salad & Achari Salad",
      "Mint Sauce & Raita",
      "Puri (Live)",
      "Assorted Naan (Live)",
      "Soft Drinks",
      "Mineral Water",
    ],
  },
  {
    title: "MENU 2",
    price: 2500,
    items: [
      "Kabuli Pulao Chicken / Beef",
      "Chicken Qorma / Chicken Karahi",
      "Chicken Boti",
      "Seekh Kabab / Reshmi Kabab",
      "Gol Gappay",
      "Chana Chaat / Dahi Baray",
      "Lahori Channay",
      "Aloo Achari",
      "Gulab Jaman & Firni Thothi",
      "Halwa Suji",
      "Puri (Live)",
      "Assorted Naan (Live)",
      "Variety of Salad",
      "Variety of Sauce",
      "Pink Tea / Green Tea",
      "Soft Drinks",
      "Mineral Water",
    ],
  },
  {
    title: "MENU 3",
    price: 3350,
    items: [
      "Chicken Sindhi Biryani",
      "Mutton White Badami Qorma",
      "Chicken Boti",
      "Seekh Kabab / Reshmi Kabab",
      "Gol Gappay",
      "Chana Chaat / Dahi Baray",
      "Lahori Channay",
      "Aloo Achari",
      "Jalebi & Firni Thothi",
      "Halwa Suji",
      "Puri (Live)",
      "Assorted Naan (Live)",
      "Variety of Salad",
      "Variety of Sauce",
      "Pink Tea",
      "Soft Drinks",
      "Mineral Water",
    ],
  },
  {
    title: "MENU 4",
    price: 4400,
    items: [
      "Zeera Pulao",
      "Mutton Paya",
      "Mutton Palak",
      "Beef Nihari",
      "Kabab Karahi Masala",
      "Chicken Shahi Tikka",
      "Lahori Fish",
      "Gol Gappay / Chana Chaat / Dahi Baray",
      "Lahori Channay",
      "Aloo Achari",
      "Ice Cream & Shahi Kheer",
      "Halwa Suji",
      "Puri (Live)",
      "Assorted Naan (Live)",
      "Variety of Salad",
      "Variety of Sauce",
      "Pink Tea / Green Tea",
      "Soft Drinks",
      "Mineral Water",
    ],
  },
];

export const baratWalimaMenus = [
  {
    title: "MENU 5",
    price: 2200,
    items: [
      "Chicken Biryani / Chicken Pulao",
      "Chicken Badami Qorma",
      "Reshmi Kabab / Chicken Tikka",
      "Dessert (2 Types)",
      "Assorted Naan (Live)",
      "Variety of Salad (Russia , Bean , Fresh",
      "Variety of Sauce (Mint , Zeera Sauce",
      "Pink Tea / Green Tea",
      "Soft Drinks",
      "Mineral Water",
    ],
  },
  {
    title: "MENU 6",
    price: 2450,
    items: [
      "Beef Kabuli Pulao / Chicken Pulao",
      "Beef Qorma / Kashmiri Beef Roghan Josh",
      "Chowmein / Alfredi Pasta",
      "Beef Kabab / Chicken Boti",
      "Dessert (2 Type)",
      "Assorted Naan (Live)",
      "Variety of Salad (Russia , Bean , Fresh",
      "Variety of Sauce (Mint , Zeera Sauce",
      "Pink Tea / Green Tea",
      "Soft Drinks",
      "Mineral Water",
    ],
  },
  {
    title: "MENU 7",
    price: 2700,
    items: [
      "Chicken Biryani / Chicken Pulao / Beef Kabuli Pulao",
      "Chicken MAnchurian with Egg Fried Rice",
      "Beef Qorma (Bone) / Beef Achari (Bone)",
      "Chicken Tikka / Malai Boti",
      "Reshmi Kabab / Beef Gola Kabab",
      "Dessert (2 Types)",
      "Assorted Naan (Live)",
      "Variety of Salad (Russia , Bean , Fresh",
      "Variety of Sauce (Mint , Zeera Sauce",
      "Pink Tea / Green Tea",
      "Soft Drinks",
      "Mineral Water",
    ],
  },
  {
    title: "MENU 8",
    price: 3350,
    items: [
      "Spanish Margarita / Soup With Fish Crackers",
      "Chicken Biryani / Chicken Pulao / Beef Kabuli Pulao",
      "Mutton Qorma / Mutton Shahi Qorma (White)",
      "Chicken Qorma",
      "Chicken Malai Boti (Boneless)",
      "Seekh Kabab / Reshmi Kabab / Beef Gola Kabab",
      "Dessert (2 Types)",
      "Assorted Naan (Live)",
      "Variety of Salad (Russia , Bean , Fresh",
      "Variety of Sauce (Mint , Zeera Sauce",
      "Pink Tea / Green Tea",
      "Soft Drinks",
      "Mineral Water",
    ],
  },
  {
    title: "MENU 9",
    price: 3800,
    items: [
      "Spanish Margarita / Soup With Fish Crackers",
      "Chicken Biryani / Chicken Pulao / Beef Kabuli Pulao",
      "Mutton Qorma / Mutton Badami Qorma",
      "Chicken Karahi / Chicken Jalfrezi",
      "Beef Steam Roast",
      "Seekh Kabab / Reshmi Kabab",
      "Chicken Malai Boti (Boneless)",
      "Dessert (3 Types)",
      "Assorted Naan (Live)",
     "Variety of Salad (Russia , Bean , Fresh",
      "Variety of Sauce (Mint , Zeera Sauce",
      "Pink Tea / Green Tea",
      "Soft Drinks",
      "Mineral Water",
    ],
  },
];

export const ronaqPremiumMenus = [
  {
    title: "RONAQ SPECIAL",
    price: 4600,
    items: [
      "Spanish Margarita / Soup With Fish Crackers",
      "Chicken Biryani / Chicken Pulao / Beef Kabuli Pulao",
      "Mutton Qorma (Red / White)",
      "Chicken Patiala Handi / Chicken Green Handi",
      "Chicken Tikka / Chicken Boti",
      "Seekh Kabab / Chicken Cheese Gola Kabab",
      "Finger Fish / Lahori Fried Fish",
      "Dessert (2 Types)",
      "Assorted Naan (Live)",
      "Variety of Salad",
      "Variety of Sauce",
      "Pink Tea / Green Tea",
      "Soft Drinks",
      "Mineral Water",
    ],
  },
  {
    title: "RONAQ PREMIUM",
    price: 5200,
    items: [
      "Spanish Margarita / Soup With Fish Crackers",
      "Chicken Biryani / Kashmiri Pulao / Beef Kabuli Pulao",
      "Black Pepper With Egg Fried Rice / Pasta",
      "Mutton Chinoti Kunna / Chicken Handi",
      "Mutton Foil Roast",
      "Chicken Lahori Tikka / Chicken Malai Tikka",
      "Seekh Kabab / Turkish Kabab",
      "Finger Fish / Lahori Fried Fish",
      "Dessert Bar",
      "Assorted Naan (Live)",
      "Salad Bar",
      "Variety of Sauce",
      "Pink Tea / Green Tea",
      "Soft Drinks",
      "Mineral Water",
    ],
  },
  {
    title: "RONAQ PREMIUM (ULTIMATE)",
    price: 6500,
    items: [
      "Ronaq Premium Soup / Jumbo Fried Prawn / Juice Bar",
      "Chicken Tempura / Sesame Fried Chicken",
      "Beef Kabuli Pulao",
      "Mutton Chinoti Kunna / Chicken Tawa Qeema",
      "Whole Lamb",
      "Mutton Gola Kabab / Reshmi Kabab",
      "Fried Fish / Lahori Fish",
      "Fried Batir / Gujrwala Grilled Batir",
      "Alfredo Pasta (Live) / Steak (Live)",
      "Chicken Cashew Nut / Chicken Almond (Live)",
      "Crunchy Finger Chicken (Live)",
      "Dessert Bar",
      "Assorted Naan (Live)",
      "Salad Bar",
      "Sauce Bar",
      "Coffee / Tea",
      "Soft Drinks (Tin)",
      "Mineral Water",
    ],
  },
];

export const desserts = [
  { id: 1, name: "Lab-e-Shireen" },
  { id: 2, name: "Gulab Jaman" },
  { id: 3, name: "Firni" },
  { id: 4, name: "Kulfa" },
  { id: 5, name: "Kheer" },
  { id: 6, name: "Gajar Halwa" },
  { id: 7, name: "Petha Halwa" },
  { id: 8, name: "Egg Halwa" },
  { id: 9, name: "Daal Halwa" },
  { id: 10, name: "Mutanjan (Special)" },
  { id: 11, name: "Ice Cream" },
  { id: 12, name: "Fruit Trifle" },
  { id: 13, name: "Cake (Any Flavour)" },
];

export const bbqMenu = [
  { name: "Beef Steam Roast", price: 300 },
  { name: "Beef Seekh Kabab", price: 300 },
  { name: "Mutton Seekh Kabab", price: 500 },
  { name: "Chicken Gola Kabab", price: 250 },
  { name: "Chicken Reshmi Kabab", price: 250 },
  { name: "Chicken Labnani Kabab", price: 250 },
  { name: "Chicken Seekh Kabab", price: 250 },
  { name: "Chicken Shish Taouk Boti (Boneless)", price: 250 },
  { name: "Chicken Afghani Boti (Boneless)", price: 250 },
  { name: "Chicken Turkish Boti", price: 300 },
  { name: "Chicken Rajistani Boti", price: 300 },
  { name: "Chicken Malai Boti (With Bone)", price: 300 },
  { name: "Chicken Malai B.B.Q", price: 300 },
];

export const muttonMenu = [
  { name: "Mutton Palak", price: 350 },
  { name: "Mutton Steam Roast", price: 700 },
  { name: "Mutton Foil", price: 700 },
  { name: "Mutton Joints Foil", price: 800 },
  { name: "Mutton Chops (BBQ)", price: 700 },
  { name: "Whole Stuffed Lamb (per kg)", price: 4500 },
];

export const seaFoodMenu = [
  { name: "Fried Fish", price: 700 },
  { name: "Finger Fish", price: 700 },
  { name: "Jumbo Prawns", price: "At Actual" },
];

export const chineseMenu = [
  { name: "Chicken Manchurian With Rice", price: 250 },
  { name: "Chicken Almond With Rice", price: 250 },
  { name: "Chicken Mongolian With Rice", price: 250 },
  { name: "Chicken Cashew Nuts With Rice", price: 250 },
  { name: "Chicken Black Pepper With Rice", price: 250 },
];

export const friedDryMenu = [
  { name: "Batair Fried", price: 450 },
  { name: "Chicken Sesame Fried", price: 300 },
  { name: "Chicken Steam Foil", price: 275 },
  { name: "Chicken Steam Roast", price: 300 },
  { name: "Chicken Pakora", price: 225 },
  { name: "Chicken Butter Fried", price: 300 },
];

export const othersMenu = [
  { name: "Halwa Puri Channay", price: 400 },
  { name: "Mix Vegetable", price: 200 },
  { name: "Palak Paneer", price: 200 },
  { name: "Sweet Dish (Extra)", price: 150 },
  { name: "Sweet Bar", price: 400 },
  { name: "Nescafe Tea Bar", price: 110 },
];

export const desiMenu = [
  { name: "Chicken Achari Handi (Boneless)", price: 250 },
  { name: "Chicken Hara Masala", price: 250 },
  { name: "Chicken Jalfrezi", price: 250 },
  { name: "Chicken Ginger (Boneless)", price: 250 },
  { name: "Chicken Handi (Boneless)", price: 250 },
  { name: "Chicken White Qorma", price: 250 },
];
